





























import { Vue, Component, Ref } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { SaveMarcaUseCase } from '@/usecases'
import {  obrigatorio } from '@/shareds/regras-de-form'

@Component

export default class DialogoDeEdicaoDeMarca extends Vue {
	@Ref() form!: HTMLFormElement
	marca = {id: '', nome: ''}
	mostra = false
	salvando = false
	obrigatorio = obrigatorio
	saveMarcaUseCase = new SaveMarcaUseCase()

	mostrar(marca) {
		this.mostra = true
		this.marca = marca
	}

	esconder() {
		this.mostra = false
	}

	async salvar() {
		if (!this.marca) return
		if (!this.form.validate()) return
		try {
			this.salvando = true 
			const marcaSalva = !this.marca.id
				? await this.saveMarcaUseCase.create(this.marca)
				: await this.saveMarcaUseCase.update(this.marca)

			this.$emit('confirmado', marcaSalva)
			AlertModule.setSuccess('Marca salva com sucesso')
		} catch(error) {
			AlertModule.setError(error.response.data[0])
		} finally {
			this.salvando = false
			this.mostra = false
		}
	}
}
